var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-input-number", {
    attrs: {
      "controls-position": "right",
      disabled: _vm.disabled,
      min: _vm.minValue,
      max: _vm.minValue,
      precision: _vm.precision
    },
    on: { change: _vm.onChanged, input: _vm.onInput },
    model: {
      value: _vm.number,
      callback: function($$v) {
        _vm.number = $$v
      },
      expression: "number"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }